import { render, staticRenderFns } from "./VShare.vue?vue&type=template&id=fdc05084&scoped=true"
import script from "./VShare.vue?vue&type=script&lang=ts"
export * from "./VShare.vue?vue&type=script&lang=ts"
import style0 from "./VShare.vue?vue&type=style&index=0&id=fdc05084&prod&lang=scss&scoped=true"
import style1 from "./VShare.vue?vue&type=style&index=1&id=fdc05084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc05084",
  null
  
)

export default component.exports